var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallsMissed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Calls_Missed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calls_Missed",
    "data-name": "Calls Missed",
    clipPath: "url(#clip-Calls_Missed)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0.003 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_067---missed-call",
    "data-name": "067---missed-call",
    transform: "translate(-0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M68.559,57.306,85.753,69.781a3.117,3.117,0,0,0,4.032-.315l10.3-10.277a3.131,3.131,0,0,0,.564-3.639C92.749,39.985,73.505,29,51,29S9.248,39.985,1.347,55.55a3.131,3.131,0,0,0,.56,3.646l10.3,10.27a3.117,3.117,0,0,0,4.032.315L33.434,57.307a3.1,3.1,0,0,0,1.207-1.84l2.069-9.351a3.717,3.717,0,0,1,2.708-2.777,46.819,46.819,0,0,1,23.136,0,3.712,3.712,0,0,1,2.707,2.777l2.069,9.351a3.1,3.1,0,0,0,1.229,1.84Z",
    transform: "translate(-0.997 20.996)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M81.429,0,51.591,3.315l9.6,9.6L45.016,29.1,17.628,4.755a5.172,5.172,0,1,0-6.872,7.73L41.788,40.069a5.172,5.172,0,0,0,7.093-.209L68.509,20.233l9.6,9.6Z",
    transform: "translate(4.777)",
    fill: "#e8eaf0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallsMissed);
export default __webpack_public_path__ + "static/media/calls-missed.3c6a1b854eec12baef4af2641f2ab319.svg";
export { ForwardRef as ReactComponent };